import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Damage } from "../models/damage.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// console.log(BASE_URL);

export const DamageApi = createApi({
  reducerPath: "damageApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Damage"],
  endpoints: (builder) => ({
    Damages: builder.query<Damage[], void>({
      query: () => "/damage",
      providesTags: ["Damage"],
    }),
    DamagesCount: builder.query<Damage[], any>({
      query: (arg) => {
        const aamarId = typeof arg === "object" ? arg?.aamarId : arg;
        return `/damage/count/${aamarId || ""}`;
      },
      providesTags: ["Damage"],
    }),
    TodayDamages: builder.query<Damage[], void>({
      query: () => "/damage/today-damage",
      providesTags: ["Damage"],
    }),
    DamagesExport: builder.query<Damage[], any>({
      query: ({ warehouse }) =>
        `/damage/export/${warehouse && warehouse !== "undefined" ? warehouse : "allWh"}`,
      providesTags: ["Damage"],
    }),
    DamageByDate: builder.query<Damage, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/damage/byDate/${startDate}/${endDate}/${warehouse && warehouse !== "undefined" ? warehouse : "allWh"}/${aamarId}`,
      providesTags: ["Damage"],
    }),
    Damage: builder.query<Damage, string>({
      query: (_id) => `/damage/${_id}`,
      providesTags: ["Damage"],
    }),
    damageDetails: builder.query<Damage, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/damage/details/${startDate}/${endDate}/${warehouse && warehouse !== "undefined" ? warehouse : "allWh"}/${aamarId}`,
      providesTags: ["Damage"],
    }),
    damageSummary: builder.query<Damage, any>({
      query: ({ startDate, endDate, warehouse, aamarId }) =>
        `/damage/summary/${startDate}/${endDate}/${warehouse && warehouse !== "undefined" ? warehouse : "allWh"}/${aamarId}`,
      providesTags: ["Damage"],
    }),
    addDamage: builder.mutation<{}, Damage>({
      query: (Damage) => ({
        url: "/damage",
        method: "POST",
        body: Damage,
      }),
      invalidatesTags: ["Damage"],
    }),
    updateDamage: builder.mutation<void, Damage>({
      query: ({ _id, ...rest }) => ({
        url: `/damage/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Damage"],
    }),
    deleteDamage: builder.mutation<void, string>({
      query: (id) => ({
        url: `/damage/delete/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["Damage"],
    }),
  }),
});

export const {
  useDamagesQuery,
  useDamagesCountQuery,
  useTodayDamagesQuery,
  useDamageByDateQuery,
  useDamagesExportQuery,
  useDamageQuery,
  useAddDamageMutation,
  useUpdateDamageMutation,
  useDeleteDamageMutation,
  useDamageDetailsQuery,
  useDamageSummaryQuery,
} = DamageApi;

export default DamageApi;
